import script from "./banned.vue?vue&type=script&setup=true&lang=ts"
export * from "./banned.vue?vue&type=script&setup=true&lang=ts"

import "./banned.vue?vue&type=style&index=0&id=ac6f2f20&scoped=true&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac6f2f20"]])

export default __exports__